import { AB_TESTING_GROUP, UserExperimentType } from '#types';

export const getExperiment = (
  experimentName: string,
  cohort: AB_TESTING_GROUP,
  experiments: UserExperimentType[],
): boolean => {
  return experiments.some((experiment) => {
    return (
      experiment.experiment === experimentName && experiment.group === cohort
    );
  });
};
